
<div class="homepage-container">
  <img mat-card-image class="image" type="image/svg+xml" src="/oem/assets/favicon.svg" alt="Electrolux">
  <div class="homepage-title">
    <h1 class="main-title">OEMCC - Homepage</h1>
    <h3>Reload the page or contact WebMaster if the error persist</h3>
  </div>
</div>
